// Мини-задания правил A2, уроки a2-l031 … a2-l050 (тикет 06 .scratch/grammar-unify).
// Каждый набор — только из пройденного к уроку правила (таблица линии A2,
// .scratch/a2-rework/spec.md) и слов банка до этого урока.
import type { MiniSet } from './types'

export const MINI_A2_2: MiniSet[] = [
  // a2-l031 — повтор блока 21–30: -yor / -ir, -eme-, lazım, zorunda, -ebilir,
  // повелительное, глаголы с -den, bazı / birkaç / her / bütün, частота.
  {
    rule: 'review-a2-block2',
    explain: 'Нового правила нет - блок 21-30 одной картиной. Спросите себя, как говорящий смотрит на действие: идёт сейчас (-yor) или бывает вообще (-ir), могу или не могу (-eme-), надо, обязан или может случиться (lazım, zorunda, -ebilir), прошу или приказываю (повелительное).',
    examples: [
      {
        parts: [
          { text: 'Horoz her sabah erken kalk', label: '', why: '' },
          { text: 'ar', label: 'вообще, обычно (-ir)', why: 'her sabah - привычка, а не "сейчас"; kalk- односложный, поэтому -ar' },
        ],
        ru: 'Петух каждое утро встаёт рано.',
      },
      {
        parts: [
          { text: 'O saatte kalk', label: '', why: '' },
          { text: 'amam', label: 'не могу (-eme-)', why: 'kalkamam - "не могу встать"; kalkmam - "не стану вставать"' },
        ],
        ru: 'Я в такое время встать не могу.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'kalk',
        baseRu: 'вставать',
        task: 'вообще, обычно (-ir)',
        context: { tr: 'Horoz her sabah beşte ___.', ru: 'Петух каждое утро встаёт в пять.' },
        slots: [
          { answer: 'kalk', options: [], label: '', why: '' },
          { answer: 'ar', options: ['ar', 'ır', 'arım'], label: 'вообще, обычно (-ir)', why: 'her sabah - привычка, значит широкое время; kalk- односложный, поэтому -ar; петух - "он", окончания лица нет' },
        ],
        answer: 'kalkar',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'köpekler',
        baseRu: 'собаки',
        task: 'глагол с -den',
        context: { tr: '___ korkarım.', ru: 'Я боюсь собак.' },
        slots: [
          { answer: 'köpekler', options: [], label: '', why: '' },
          { answer: 'den', options: ['den', 'i', 'e'], label: 'от чего? (-den)', why: 'korkmak просит -den: по-турецки боятся "от собак"' },
        ],
        answer: 'köpeklerden',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'dokun',
        baseRu: 'трогать',
        task: 'не трогай! (одному)',
        context: { tr: 'Keçiye ___!', ru: 'Не трогай козу!' },
        slots: [
          { answer: 'dokun', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'mayın', 'maz'], label: 'запрет, sen (-ma)', why: 'одному - -ma; -mayın - вежливо или многим' },
        ],
        answer: 'dokunma',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'gün',
        baseRu: 'день',
        task: 'как часто: период',
        context: { tr: '___ iki kez süt içerim.', ru: 'Я пью молоко два раза в день.' },
        slots: [
          { answer: 'gün', options: [], label: '', why: '' },
          { answer: 'de', options: ['de', 'e', 'den'], label: 'в период (-de)', why: 'частота: период с -de впереди, число за ним - günde iki kez' },
        ],
        answer: 'günde',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'iç',
        baseRu: 'пить',
        task: 'ответ на предложение',
        context: { tr: '- Çay içer misin? - Evet, ___.', ru: '- Будешь чай? - Да, буду.' },
        slots: [
          { answer: 'iç', options: [], label: '', why: '' },
          { answer: 'erim', options: ['erim', 'iyorum', 'ebilirim'], label: 'согласие (-ir)', why: 'на предложение с -ir отвечают -ir; içiyorum - "пью прямо сейчас"' },
        ],
        answer: 'içerim',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'kalk',
        baseRu: 'вставать',
        task: 'не могу',
        context: { tr: 'Beşte mi? O saatte ___!', ru: 'В пять?! Я в такое время встать не могу!' },
        slots: [
          { answer: 'kalk', options: [], label: '', why: '' },
          { answer: 'amam', options: ['amam', 'mam', 'arım'], label: 'не могу (-eme-)', why: '"не могу" - -ama-; kalkmam - "не стану", прозвучит грубо' },
        ],
        answer: 'kalkamam',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'git',
        baseRu: 'идти, ехать',
        task: 'мне надо',
        context: { tr: 'Yarın ___ lazım.', ru: 'Мне завтра надо уехать.' },
        slots: [
          { answer: 'git', options: [], label: '', why: '' },
          { answer: 'mem', options: ['mem', 'mek', 'meliyim'], label: '-me + "мой"', why: '"мне надо" - окончание "мой" стоит на -me: gitmem lazım' },
        ],
        answer: 'gitmem',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'koyun',
        baseRu: 'овца',
        task: 'множественное число после bütün',
        context: { tr: 'Bütün ___ uyuyor.', ru: 'Все овцы спят.' },
        slots: [
          { answer: 'koyun', options: [], label: '', why: '' },
          { answer: 'lar', options: ['lar', 'ler', 'u'], label: 'множественное число (-lar)', why: 'bazı и bütün - с множественным; birkaç и her - с единственным' },
        ],
        answer: 'koyunlar',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Hava karlı.',
        sourceRu: 'снежно',
        instruction: 'Скажите "может быть" (-ebilir)',
        answer: 'Hava karlı olabilir.',
        variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'abilir', label: 'может быть (-ebilir)', why: 'возможность: olabilir - "может случиться"' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Erken kalkıyorum.',
        sourceRu: 'я встаю рано',
        instruction: 'Скажите "я вынужден" (-mek zorundayım)',
        answer: 'Erken kalkmak zorundayım.',
        variants: [],
        breakdown: [
          { text: 'kalk', label: '', why: '' },
          { text: 'mak zorunda', label: 'вынужден (-mek zorunda)', why: 'глагол - в форме -mak, лицо - на zorunda' },
          { text: 'yım', label: 'я', why: 'после гласной - y' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Не трогайте козу! (вежливо)',
        instruction: 'Скажите это по-турецки',
        answer: 'Keçiye dokunmayın!',
        variants: [],
        breakdown: [
          { text: 'dokun', label: '', why: '' },
          { text: 'mayın', label: 'запрет, siz (-mayın)', why: 'вежливо или многим - -mayın' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l032 — указательные в падежах: bunu, şunu, bunda.
  {
    rule: 'demonstrative-accusative-clothes',
    explain: 'Bu, şu, o меняются по падежам, как обычные слова, только перед окончанием встаёт n: bunu, buna, bunda, bundan; şunu, şuna; onu, ona. Падеж берёт только последнее слово: bu eteği, а bunu - когда bu стоит один, вместо предмета.',
    examples: [
      {
        parts: [
          { text: 'Bu', label: '', why: '' },
          { text: 'nu', label: 'кого? что? (-i)', why: 'у местоимений связка n: bunu, не "buyu"' },
          { text: ' alıyorum', label: '', why: '' },
        ],
        ru: 'Беру это.',
      },
      {
        parts: [
          { text: 'Bu', label: '', why: '' },
          { text: 'nda', label: 'где? (-de)', why: 'bu + n + da' },
          { text: ' indirim var mı?', label: '', why: '' },
        ],
        ru: 'На это есть скидка?',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'bu',
        baseRu: 'это',
        task: 'кого? что? (-i)',
        context: { tr: '___ alıyorum.', ru: 'Беру это.' },
        slots: [
          { answer: 'bu', options: [], label: '', why: '' },
          { answer: 'nu', options: ['nu', 'yu', 'u'], label: 'кого? что? (-i)', why: 'у местоимений связка n, а не y, как в masayı' },
        ],
        answer: 'bunu',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'şu',
        baseRu: 'вот то',
        task: 'кого? что? (-i)',
        context: { tr: '___ deneyebilir miyim?', ru: 'Можно примерить вон то?' },
        slots: [
          { answer: 'şu', options: [], label: '', why: '' },
          { answer: 'nu', options: ['nu', 'nü', 'yu'], label: 'кого? что? (-i)', why: 'связка n; после u - -u' },
        ],
        answer: 'şunu',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bu',
        baseRu: 'это',
        task: 'где? (-de)',
        context: { tr: '___ indirim var mı?', ru: 'На это есть скидка?' },
        slots: [
          { answer: 'bu', options: [], label: '', why: '' },
          { answer: 'nda', options: ['nda', 'nde', 'da'], label: 'где? (-de)', why: 'bu + n + da; последняя гласная u, поэтому -da' },
        ],
        answer: 'bunda',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bu',
        baseRu: 'это',
        task: 'от чего? (-den)',
        context: { tr: '___ hoşlanmıyorum.', ru: 'Мне это не нравится.' },
        slots: [
          { answer: 'bu', options: [], label: '', why: '' },
          { answer: 'ndan', options: ['ndan', 'nu', 'dan'], label: 'от чего? (-den)', why: 'hoşlanmak просит -den; у bu связка n: bundan' },
        ],
        answer: 'bundan',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bu',
        baseRu: 'это',
        task: 'чему? (-e)',
        context: { tr: '___ ihtiyacım yok.', ru: 'Мне это не нужно.' },
        slots: [
          { answer: 'bu', options: [], label: '', why: '' },
          { answer: 'na', options: ['na', 'ya', 'nu'], label: 'чему? (-e)', why: 'ihtiyacım var / yok - "в чём нужда?" с -e; связка n: buna' },
        ],
        answer: 'buna',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'bunlar',
        baseRu: 'эти',
        task: 'кого? что? (-i)',
        context: { tr: '___ da al.', ru: 'Возьми и эти.' },
        slots: [
          { answer: 'bunlar', options: [], label: '', why: '' },
          { answer: 'ı', options: ['ı', 'nı', 'i'], label: 'кого? что? (-i)', why: 'во множественном n уже внутри: bunlar - bunları' },
        ],
        answer: 'bunları',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Bu eteği alıyorum.',
        sourceRu: 'я беру эту юбку',
        instruction: 'Скажите без предмета: "беру это"',
        answer: 'Bunu alıyorum.',
        variants: [],
        breakdown: [
          { text: 'bu', label: '', why: '' },
          { text: 'nu', label: 'кого? что? (-i)', why: 'bu стоит один, вместо предмета, - теперь падеж берёт он: bunu' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Şunu deneyebilir miyim?',
        sourceRu: 'можно примерить вон то?',
        instruction: 'Добавьте предмет - kazak (свитер)',
        answer: 'Şu kazağı deneyebilir miyim?',
        variants: [],
        breakdown: [
          { text: 'kazağ', label: '', why: 'k между гласными становится ğ' },
          { text: 'ı', label: 'кого? что? (-i)', why: 'падеж берёт только последнее слово, şu не меняется; "şunu kazağı" - ошибка' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Беру эту юбку.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bu eteği alıyorum.',
        variants: [],
        breakdown: [
          { text: 'eteğ', label: '', why: 'k между гласными становится ğ' },
          { text: 'i', label: 'кого? что? (-i)', why: 'по-русски склоняются оба слова, по-турецки - только последнее: bu eteği' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Мне это не нужно.',
        instruction: 'Скажите это по-турецки',
        answer: 'Buna ihtiyacım yok.',
        variants: [],
        breakdown: [
          { text: 'bu', label: '', why: '' },
          { text: 'na', label: 'чему? (-e)', why: 'ihtiyacım yok просит -e; связка n: buna' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l034 — возвратное -n и kendi.
  {
    rule: 'reflexive-kendi',
    explain: 'Суффикс -n / -ın поворачивает действие на себя - как русское -ся: giymek - giyinmek, yıkamak - yıkanmak. "Сам, себя" - это kendi с окончанием лица: Bunu kendim yaptım, Kendini nasıl hissediyorsun?; kendi kendime - "сам, без помощи".',
    examples: [
      {
        parts: [
          { text: 'Hızlı giy', label: '', why: '' },
          { text: 'in', label: 'на себя (-ın)', why: 'после согласной -ın / -in по гармонии: giy- даёт giyin-' },
          { text: 'dim', label: 'я, прошедшее', why: '' },
        ],
        ru: 'Я быстро оделся.',
      },
      {
        parts: [
          { text: 'Bunu kendi', label: '', why: '' },
          { text: 'm', label: 'я', why: 'kendi меняется по лицам: kendim, kendin, kendisi' },
          { text: ' yaptım', label: '', why: '' },
        ],
        ru: 'Я сделал это сам.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'giy',
        baseRu: 'надевать',
        task: 'одеться (на себя) · я, прошедшее',
        context: { tr: 'Sabah hızlı ___.', ru: 'Утром я быстро оделся.' },
        slots: [
          { answer: 'giy', options: [], label: '', why: '' },
          { answer: 'in', options: ['in', 'n', 'ın'], label: 'на себя (-ın)', why: 'после согласной -ın / -in; в giy- гласная i, поэтому -in' },
          { answer: 'dim', options: ['dim', 'dım', 'tim'], label: 'я, прошедшее', why: 'после звонкой n - d' },
        ],
        answer: 'giyindim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yıka',
        baseRu: 'мыть',
        task: 'мыться (на себя) · я, прошедшее',
        context: { tr: 'Dün akşam ___.', ru: 'Вчера вечером я помылся.' },
        slots: [
          { answer: 'yıka', options: [], label: '', why: '' },
          { answer: 'n', options: ['n', 'ın', 'in'], label: 'на себя (-n)', why: 'после гласной - просто n: yıka- даёт yıkan-' },
          { answer: 'dım', options: ['dım', 'dim', 'tım'], label: 'я, прошедшее', why: 'после звонкой n - d; последняя гласная a, поэтому -dı' },
        ],
        answer: 'yıkandım',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kendi',
        baseRu: 'сам',
        task: 'я сам',
        context: { tr: 'Bunu ___ yaptım.', ru: 'Я сделал это сам.' },
        slots: [
          { answer: 'kendi', options: [], label: '', why: '' },
          { answer: 'm', options: ['m', 'n', 'si'], label: 'я', why: 'ben - kendim; kendin - "ты сам", kendisi - "он сам"' },
        ],
        answer: 'kendim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kendi',
        baseRu: 'сам, себя',
        task: 'себя (я)',
        context: { tr: '___ iyi hissediyorum.', ru: 'Я чувствую себя хорошо.' },
        slots: [
          { answer: 'kendi', options: [], label: '', why: '' },
          { answer: 'mi', options: ['mi', 'ni', 'm'], label: 'себя, я (-i)', why: '"себя" меняется по лицам: ben - kendimi; kendini - это "ты" или "он"' },
        ],
        answer: 'kendimi',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yıka',
        baseRu: 'мыть',
        task: 'сейчас · я',
        context: { tr: 'Ellerimi ___.', ru: 'Я мою руки.' },
        slots: [
          { answer: 'yık', options: [], label: '', why: 'a перед -yor уходит' },
          { answer: 'ıyorum', options: ['ıyorum', 'anıyorum'], label: 'сейчас, я (-yor)', why: 'есть предмет (ellerimi) - глагол обычный; yıkanıyorum - "моюсь целиком"' },
        ],
        answer: 'yıkıyorum',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'oda',
        baseRu: 'комната',
        task: 'моя (после kendi)',
        context: { tr: 'Artık kendi ___ var.', ru: 'Теперь у меня своя комната.' },
        slots: [
          { answer: 'oda', options: [], label: '', why: '' },
          { answer: 'm', options: ['m', 'sı', 'n'], label: 'мой (-m)', why: 'kendi перед существительным - "свой", а притяжательное у существительного остаётся: kendi odam' },
        ],
        answer: 'odam',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'kendi',
        baseRu: 'сам',
        task: 'сам, без помощи (я)',
        context: { tr: 'Artık kendi ___ giyiniyorum.', ru: 'Теперь я одеваюсь сам, без помощи.' },
        slots: [
          { answer: 'kendi', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'ne', 'mi'], label: 'себе, я (-e)', why: 'kendi kendime - "сам, без помощи"; для "я" - kendime' },
        ],
        answer: 'kendime',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Ben kendimi iyi hissediyorum.',
        sourceRu: 'я чувствую себя хорошо',
        instruction: 'Скажите про "ты" (sen)',
        answer: 'Sen kendini iyi hissediyorsun.',
        variants: ['Kendini iyi hissediyorsun.'],
        breakdown: [
          { text: 'kendi', label: '', why: '' },
          { text: 'ni', label: 'себя, ты (-i)', why: 'sen - kendini; "sen kendimi" - ошибка' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Ребёнок разделся.',
        instruction: 'Скажите это по-турецки',
        answer: 'Çocuk soyundu.',
        variants: [],
        breakdown: [
          { text: 'soy', label: '', why: '' },
          { text: 'un', label: 'на себя (-ın)', why: 'после согласной -un по гармонии: soy- даёт soyun-' },
          { text: 'du', label: 'прошедшее (-di)', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Купи себе пиджак.',
        instruction: 'Скажите это по-турецки',
        answer: 'Kendine bir ceket al.',
        variants: ['Kendine ceket al.'],
        breakdown: [
          { text: 'kendi', label: '', why: '' },
          { text: 'ne', label: 'себе, ты (-e)', why: 'кому? - -e; sen - kendine' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },


  // a2-l043 — изафет без родительного: Türk kahvesi, otobüs durağı.
  {
    rule: 'izafet-compound',
    explain: 'Türk kahvesi - "турецкий кофе": хвост -ı / -sı только у второго слова. Так турецкий строит названия и виды вещей: otobüs durağı, ev anahtarı, doğum günü. Первое слово отвечает на вопрос "какой?" или "для чего?", родительного у него нет.',
    examples: [
      {
        parts: [
          { text: 'Türk kahve', label: '', why: '' },
          { text: 'si', label: 'его (-sı)', why: 'хвост только у второго слова; после гласной -sı / -si' },
        ],
        ru: 'турецкий кофе',
      },
      {
        parts: [
          { text: 'otobüs durağ', label: '', why: 'k между гласными - ğ' },
          { text: 'ı', label: 'его (-ı)', why: 'какая остановка? автобусная; родительного нет' },
        ],
        ru: 'автобусная остановка',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'kahve',
        baseRu: 'кофе',
        task: 'какой? (связка -ı)',
        context: { tr: 'Türk ___ içiyorum.', ru: 'Я пью турецкий кофе.' },
        slots: [
          { answer: 'kahve', options: [], label: '', why: '' },
          { answer: 'si', options: ['si', 'sı', 'yi'], label: 'его (-sı)', why: 'после гласной - -sı / -si; последняя e - -si' },
        ],
        answer: 'kahvesi',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'durak',
        baseRu: 'остановка',
        task: 'какой? (связка -ı)',
        context: { tr: 'Otobüs ___ nerede?', ru: 'Где автобусная остановка?' },
        slots: [
          { answer: 'durağ', options: [], label: '', why: 'k между гласными - ğ' },
          { answer: 'ı', options: ['ı', 'i', 'sı'], label: 'его (-ı)', why: 'после согласной -ı; последняя a - -ı' },
        ],
        answer: 'durağı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'anahtar',
        baseRu: 'ключ',
        task: 'для чего? (связка -ı)',
        context: { tr: 'Ev ___ çantamda.', ru: 'Ключ от дома у меня в сумке.' },
        slots: [
          { answer: 'anahtar', options: [], label: '', why: '' },
          { answer: 'ı', options: ['ı', 'ın', 'i'], label: 'его (-ı)', why: 'какой ключ? от дома: ev anahtarı, у ev окончания нет' },
        ],
        answer: 'anahtarı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bardak',
        baseRu: 'стакан',
        task: 'для чего? (связка -ı)',
        context: { tr: 'Çay ___ masada.', ru: 'Стакан для чая на столе.' },
        slots: [
          { answer: 'bardağ', options: [], label: '', why: 'k между гласными - ğ' },
          { answer: 'ı', options: ['ı', 'i', 'sı'], label: 'его (-ı)', why: 'çay bardağı - стакан для чая; последняя a - -ı' },
        ],
        answer: 'bardağı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'istasyon',
        baseRu: 'станция',
        task: 'связка -ı · куда? (-e)',
        context: { tr: 'Tren ___ gidiyorum.', ru: 'Я еду на вокзал.' },
        slots: [
          { answer: 'istasyon', options: [], label: '', why: '' },
          { answer: 'u', options: ['u', 'a', 'un'], label: 'его (-ı)', why: 'tren istasyonu - какая станция? железнодорожная' },
          { answer: 'na', options: ['na', 'a', 'ya'], label: 'куда? (-e)', why: 'падеж после -ı получает n: istasyonuna' },
        ],
        answer: 'istasyonuna',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'merkez',
        baseRu: 'центр',
        task: 'связка -ı · где? (-de)',
        context: { tr: 'Şehir ___ oturuyorum.', ru: 'Я живу в центре города.' },
        slots: [
          { answer: 'merkez', options: [], label: '', why: '' },
          { answer: 'i', options: ['i', 'ı', 'in'], label: 'его (-ı)', why: 'şehir merkezi - центр города; последняя e - -i' },
          { answer: 'nde', options: ['nde', 'de', 'da'], label: 'где? (-de)', why: 'падеж после -ı получает n: merkezinde' },
        ],
        answer: 'merkezinde',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'doktor',
        baseRu: 'врач',
        task: 'связка -ı · куда? (-e)',
        context: { tr: 'Yarın diş ___ gideceğim.', ru: 'Завтра пойду к зубному врачу.' },
        slots: [
          { answer: 'doktor', options: [], label: '', why: '' },
          { answer: 'u', options: ['u', 'ı', 'un'], label: 'его (-ı)', why: 'diş doktoru - какой врач? зубной; последняя o - -u' },
          { answer: 'na', options: ['na', 'a', 'ya'], label: 'куда? (-e)', why: 'падеж после -ı получает n: doktoruna' },
        ],
        answer: 'doktoruna',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Ev anahtarı nerede?',
        sourceRu: 'где ключ от дома?',
        instruction: 'Скажите "мой ключ от дома" - "мой" встаёт вместо -ı',
        answer: 'Ev anahtarım nerede?',
        variants: [],
        breakdown: [
          { text: 'anahtar', label: '', why: '' },
          { text: 'ım', label: 'мой (-ım)', why: '"мой" встаёт вместо -ı, а не после него: anahtarı - anahtarım' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Я пью турецкий кофе.',
        instruction: 'Скажите это по-турецки',
        answer: 'Türk kahvesi içiyorum.',
        variants: [],
        breakdown: [
          { text: 'kahve', label: '', why: '' },
          { text: 'si', label: 'его (-sı)', why: 'без хвоста "Türk kahve" не пара' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Где автобусная остановка?',
        instruction: 'Скажите это по-турецки',
        answer: 'Otobüs durağı nerede?',
        variants: [],
        breakdown: [
          { text: 'durağ', label: '', why: 'k между гласными - ğ' },
          { text: 'ı', label: 'его (-ı)', why: 'автобусная остановка - otobüs durağı, у otobüs окончания нет' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l040 — Türkiye'nin ekonomisi или Türkiye ekonomisi.
  {
    rule: 'compounding-vs-izafet',
    explain: 'Задайте первому слову вопрос: "какой?" - хвост только у второго слова (Türkiye ekonomisi, para sorunu); "чей именно?" - нужен родительный (Türkiye\'nin ekonomisi). Родительный обязателен, если первое слово - имя, местоимение или стоит с bu, şu, o, "мой" или прилагательным: bu şehrin nüfusu.',
    examples: [
      {
        parts: [
          { text: 'bu şehr', label: '', why: 'i выпадает перед гласной' },
          { text: 'in', label: 'чей? (-ın)', why: 'с bu первое слово конкретное - родительный обязателен' },
          { text: ' nüfus', label: '', why: '' },
          { text: 'u', label: 'его (-ı)', why: '' },
        ],
        ru: 'население этого города',
      },
      {
        parts: [
          { text: 'Türkiye', label: '', why: '' },
          { text: '\'nin', label: 'чей? (-ın)', why: 'валюта именно Турции' },
          { text: ' para birim', label: '', why: '' },
          { text: 'i', label: 'его (-ı)', why: '"его" не удваивается: para birimi, не "birimisi"' },
        ],
        ru: 'валюта Турции',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'Ali',
        baseRu: 'Али',
        task: 'чей? (-ın)',
        context: { tr: '___ parası yok.', ru: 'У Али нет денег.' },
        slots: [
          { answer: 'Ali', options: [], label: '', why: '' },
          { answer: '\'nin', options: ['\'nin', '\'nın', '\'in'], label: 'чей? (-ın)', why: 'имя человека - родительный обязателен; после гласной -nin' },
        ],
        answer: 'Ali\'nin',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'şehir',
        baseRu: 'город',
        task: 'чей? (с bu)',
        context: { tr: 'Bu ___ nüfusu büyük.', ru: 'Население этого города большое.' },
        slots: [
          { answer: 'şehr', options: [], label: '', why: 'i выпадает перед гласной' },
          { answer: 'in', options: ['in', 'i', 'ın'], label: 'чей? (-ın)', why: 'bu делает слово конкретным - "bu şehir nüfusu" нельзя' },
        ],
        answer: 'şehrin',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'sorun',
        baseRu: 'проблема',
        task: 'какой? (только -ı)',
        context: { tr: 'Para ___ herkesin sorunu.', ru: 'Проблема с деньгами - общая проблема.' },
        slots: [
          { answer: 'sorun', options: [], label: '', why: '' },
          { answer: 'u', options: ['u', 'un', 'ı'], label: 'его (-ı)', why: 'какая проблема? денежная - хвост только у второго слова' },
        ],
        answer: 'sorunu',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'o',
        baseRu: 'он, она',
        task: 'чей? (местоимение)',
        context: { tr: 'Bu ___ sorunu.', ru: 'Это его проблема.' },
        slots: [
          { answer: 'o', options: [], label: '', why: '' },
          { answer: 'nun', options: ['nun', 'nu', 'n'], label: 'чей? (-ın)', why: 'местоимение - родительный обязателен: onun sorunu' },
        ],
        answer: 'onun',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'birim',
        baseRu: 'единица',
        task: 'его (-ı) в паре с родительным',
        context: { tr: 'Türkiye\'nin para ___ lira.', ru: 'Валюта Турции - лира.' },
        slots: [
          { answer: 'birim', options: [], label: '', why: '' },
          { answer: 'i', options: ['i', 'isi', 'in'], label: 'его (-ı)', why: 'para birimi стала вторым словом - "его" не удваивается, не "birimisi"' },
        ],
        answer: 'birimi',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'köy',
        baseRu: 'деревня',
        task: 'чей? (с прилагательным)',
        context: { tr: 'Küçük ___ sorunu ne?', ru: 'В чём проблема маленькой деревни?' },
        slots: [
          { answer: 'köy', options: [], label: '', why: '' },
          { answer: 'ün', options: ['ün', 'ü', 'de'], label: 'чей? (-ın)', why: 'прилагательное перед словом делает его конкретным - родительный обязателен' },
        ],
        answer: 'köyün',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Şehir nüfusu büyük.',
        sourceRu: 'городское население большое',
        instruction: 'Скажите "население этого города" - добавьте bu',
        answer: 'Bu şehrin nüfusu büyük.',
        variants: [],
        breakdown: [
          { text: 'şehr', label: '', why: 'i выпадает перед гласной' },
          { text: 'in', label: 'чей? (-ın)', why: 'bu не встаёт внутрь цельного названия - нужен родительный' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Турецкая экономика неплохая.',
        instruction: 'Скажите это по-турецки (как название, тема)',
        answer: 'Türkiye ekonomisi fena değil.',
        variants: ['Türk ekonomisi fena değil.'],
        breakdown: [
          { text: 'ekonomi', label: '', why: '' },
          { text: 'si', label: 'его (-sı)', why: 'какая экономика? турецкая - хвост только у второго слова' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Валюта моей страны - лира.',
        instruction: 'Скажите это по-турецки',
        answer: 'Ülkemin para birimi lira.',
        variants: [],
        breakdown: [
          { text: 'ülke', label: '', why: '' },
          { text: 'm', label: 'мой', why: '' },
          { text: 'in', label: 'чей? (-ın)', why: 'слово с "мой" - конкретное, родительный обязателен' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l041 — рассказ в прошедшем: -di и -ydı вместе.
  {
    rule: 'past-narrative',
    explain: 'Рассказ о прошлом собирается из двух деталей: что случилось - глагол с -di (doğdum, taşındık); каким всё было - слово с -ydı (küçüktüm, evdeydik, vardı). "Был" - не отдельное слово и не var: küçüktüm, а не "küçük vardım".',
    examples: [
      {
        parts: [
          { text: 'Bu şehirde doğ', label: '', why: '' },
          { text: 'dum', label: 'событие (-di)', why: 'глагол - что случилось' },
        ],
        ru: 'Я родился в этом городе.',
      },
      {
        parts: [
          { text: 'O zamanlar çok küçük', label: '', why: '' },
          { text: 'tüm', label: 'фон (-ydı), я', why: 'прилагательное - каким был; после глухой k - -tü' },
        ],
        ru: 'В те времена я был совсем маленьким.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'doğ',
        baseRu: 'родиться',
        task: 'событие (-di) · я',
        context: { tr: 'İzmir\'de ___.', ru: 'Я родился в Измире.' },
        slots: [
          { answer: 'doğ', options: [], label: '', why: '' },
          { answer: 'dum', options: ['dum', 'tum', 'dım'], label: 'событие (-di), я', why: 'после звонкой ğ - d; последняя o, поэтому -du' },
        ],
        answer: 'doğdum',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'küçük',
        baseRu: 'маленький',
        task: 'фон (-ydı) · я',
        context: { tr: 'O zamanlar çok ___.', ru: 'В те времена я был совсем маленьким.' },
        slots: [
          { answer: 'küçük', options: [], label: '', why: '' },
          { answer: 'tüm', options: ['tüm', 'düm', 'tım'], label: 'фон (-ydı), я', why: '"был" прилипает к слову; после глухой k - t' },
        ],
        answer: 'küçüktüm',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'evde',
        baseRu: 'дома',
        task: 'фон (-ydı) · мы',
        context: { tr: 'Dün akşam ___.', ru: 'Вчера вечером мы были дома.' },
        slots: [
          { answer: 'evde', options: [], label: '', why: '' },
          { answer: 'ydik', options: ['ydik', 'dik', 'ydık'], label: 'фон (-ydı), мы', why: 'место - где было; после гласной - y' },
        ],
        answer: 'evdeydik',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'var',
        baseRu: 'есть',
        task: 'было (-ydı)',
        context: { tr: 'Eskiden burada bir park ___.', ru: 'Раньше здесь был парк.' },
        slots: [
          { answer: 'var', options: [], label: '', why: '' },
          { answer: 'dı', options: ['dı', 'tı', 'dır'], label: 'фон (-ydı)', why: 'var - vardı "был, имелся"' },
        ],
        answer: 'vardı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'taşın',
        baseRu: 'переезжать',
        task: 'событие (-di) · мы',
        context: { tr: 'Önce İzmir\'e ___, sonra Ankara\'ya.', ru: 'Сначала мы переехали в Измир, потом в Анкару.' },
        slots: [
          { answer: 'taşın', options: [], label: '', why: '' },
          { answer: 'dık', options: ['dık', 'dıydık', 'ıyoruz'], label: 'событие (-di), мы', why: 'переезд - событие, поэтому у глагола -dı; -ydı - для фона, не для глагола' },
        ],
        answer: 'taşındık',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'küçük',
        baseRu: 'маленький',
        task: 'фон (-ydı) · он, она',
        context: { tr: 'Evimiz çok ___.', ru: 'Наш дом был очень маленьким.' },
        slots: [
          { answer: 'küçük', options: [], label: '', why: '' },
          { answer: 'tü', options: ['tü', 'dü', 'tüm'], label: 'фон (-ydı)', why: 'дом - "он", окончания лица нет; после глухой k - t' },
        ],
        answer: 'küçüktü',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'yok',
        baseRu: 'нет',
        task: 'не было (-ydı)',
        context: { tr: 'Köyde okul ___.', ru: 'В деревне не было школы.' },
        slots: [
          { answer: 'yok', options: [], label: '', why: '' },
          { answer: 'tu', options: ['tu', 'du', 'tı'], label: 'фон (-ydı)', why: 'yok - yoktu; после глухой k - t' },
        ],
        answer: 'yoktu',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Evimiz küçük.',
        sourceRu: 'наш дом маленький',
        instruction: 'Расскажите о прошлом: "был" - окончанием на слове',
        answer: 'Evimiz küçüktü.',
        variants: [],
        breakdown: [
          { text: 'küçük', label: '', why: '' },
          { text: 'tü', label: 'фон (-ydı)', why: 'не "küçük vardı": var - это "есть, имеется"' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Sonra İstanbul\'a taşınıyoruz.',
        sourceRu: 'потом мы переезжаем в Стамбул',
        instruction: 'Расскажите в прошедшем (-di)',
        answer: 'Sonra İstanbul\'a taşındık.',
        variants: [],
        breakdown: [
          { text: 'taşın', label: '', why: '' },
          { text: 'dık', label: 'событие (-di), мы', why: 'что случилось - глагол с -dı' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'В те времена мы были очень счастливы.',
        instruction: 'Скажите это по-турецки',
        answer: 'O zamanlar çok mutluyduk.',
        variants: [],
        breakdown: [
          { text: 'mutlu', label: '', why: '' },
          { text: 'yduk', label: 'фон (-ydı), мы', why: 'каким было - -ydı; после гласной - y' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l044 — планы: -meyi düşünüyorum, -meye çalışıyorum, -meye karar verdim.
  {
    rule: 'future-plans-infinitive',
    explain: 'О планах говорят тремя глаголами, и каждый ставит перед собой глагол на -mek в своём падеже: düşünmek - -meyi (taşınmayı düşünüyorum), karar vermek и çalışmak - -meye (taşınmaya karar verdim, konuşmaya çalışıyorum). Голый -mek бывает только с istemek.',
    examples: [
      {
        parts: [
          { text: 'Taşın', label: '', why: '' },
          { text: 'mayı', label: 'что? (-meyi)', why: 'düşünmek берёт винительный; k уходит, y связывает гласные' },
          { text: ' düşünüyorum', label: '', why: '' },
        ],
        ru: 'Я подумываю переехать.',
      },
      {
        parts: [
          { text: 'Taşın', label: '', why: '' },
          { text: 'maya', label: 'к чему? (-meye)', why: 'karar vermek берёт дательный' },
          { text: ' karar verdim', label: '', why: '' },
        ],
        ru: 'Я решил переехать.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'yaşa',
        baseRu: 'жить',
        task: 'düşünmek: -meyi',
        context: { tr: 'Türkiye\'de ___ düşünüyorum.', ru: 'Я подумываю жить в Турции.' },
        slots: [
          { answer: 'yaşa', options: [], label: '', why: '' },
          { answer: 'mayı', options: ['mayı', 'maya', 'mak'], label: 'что? (-meyi)', why: 'düşünmek - винительный, как в Seni düşünüyorum' },
        ],
        answer: 'yaşamayı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'taşın',
        baseRu: 'переезжать',
        task: 'karar vermek: -meye',
        context: { tr: '___ karar verdim.', ru: 'Я решил переехать.' },
        slots: [
          { answer: 'taşın', options: [], label: '', why: '' },
          { answer: 'maya', options: ['maya', 'mayı', 'mak'], label: 'к чему? (-meye)', why: 'karar vermek - дательный; "taşınmak karar verdim" - ошибка' },
        ],
        answer: 'taşınmaya',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'konuş',
        baseRu: 'говорить',
        task: 'çalışmak "стараться": -meye',
        context: { tr: 'Türkçe ___ çalışıyorum.', ru: 'Я стараюсь говорить по-турецки.' },
        slots: [
          { answer: 'konuş', options: [], label: '', why: '' },
          { answer: 'maya', options: ['maya', 'mayı', 'mak'], label: 'к чему? (-meye)', why: 'çalışmak с -meye - "стараться"' },
        ],
        answer: 'konuşmaya',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yap',
        baseRu: 'делать',
        task: 'düşünmek: -meyi',
        context: { tr: 'Ne ___ düşünüyorsun?', ru: 'Что ты собираешься делать?' },
        slots: [
          { answer: 'yap', options: [], label: '', why: '' },
          { answer: 'mayı', options: ['mayı', 'maya', 'mak'], label: 'что? (-meyi)', why: 'düşünmek - винительный: yapmayı' },
        ],
        answer: 'yapmayı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'taşın',
        baseRu: 'переезжать',
        task: 'форма при istemek',
        context: { tr: '___ istiyorum.', ru: 'Я хочу переехать.' },
        slots: [
          { answer: 'taşın', options: [], label: '', why: '' },
          { answer: 'mak', options: ['mak', 'mayı', 'maya'], label: 'голый -mek', why: 'голый -mek бывает только с istemek' },
        ],
        answer: 'taşınmak',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'kalk',
        baseRu: 'вставать',
        task: 'çalışmak "стараться": -meye',
        context: { tr: 'Sabah erken ___ çalışacağım.', ru: 'Постараюсь вставать рано утром.' },
        slots: [
          { answer: 'kalk', options: [], label: '', why: '' },
          { answer: 'maya', options: ['maya', 'mayı', 'mak'], label: 'к чему? (-meye)', why: 'без -meye çalışmak - "работать", с -meye - "стараться"' },
        ],
        answer: 'kalkmaya',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'öğren',
        baseRu: 'учить',
        task: 'başlamak: -meye',
        context: { tr: 'Geçen yıl Türkçe ___ başladım.', ru: 'В прошлом году я начал учить турецкий.' },
        slots: [
          { answer: 'öğren', options: [], label: '', why: '' },
          { answer: 'meye', options: ['meye', 'meyi', 'mek'], label: 'к чему? (-meye)', why: 'başlamak - дательный, как işe başladım; e, поэтому -meye' },
        ],
        answer: 'öğrenmeye',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Taşınmayı düşünüyorum.',
        sourceRu: 'я подумываю переехать',
        instruction: 'Скажите, что уже решили (karar verdim)',
        answer: 'Taşınmaya karar verdim.',
        variants: [],
        breakdown: [
          { text: 'taşın', label: '', why: '' },
          { text: 'maya', label: 'к чему? (-meye)', why: 'düşünmek - -meyi, karar vermek - -meye' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Я стараюсь каждый день немного читать.',
        instruction: 'Скажите это по-турецки',
        answer: 'Her gün biraz okumaya çalışıyorum.',
        variants: [],
        breakdown: [
          { text: 'oku', label: '', why: '' },
          { text: 'maya', label: 'к чему? (-meye)', why: 'çalışmak "стараться" - -meye' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Я решила учить турецкий.',
        instruction: 'Скажите это по-турецки',
        answer: 'Türkçe öğrenmeye karar verdim.',
        variants: [],
        breakdown: [
          { text: 'öğren', label: '', why: '' },
          { text: 'meye', label: 'к чему? (-meye)', why: 'karar vermek - дательный; по-русски "решила учить" - голый глагол, по-турецки - нет' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l045 — обещание -ir против решённого -ecek.
  {
    rule: 'future-vs-aorist',
    explain: '-ecek - решение уже принято, это план: Yarın geleceğim. -ir - готовность и обещание, решение рождается прямо сейчас, часто в ответ на просьбу: Tamam, gelirim. Отрицание -mem - отказ, "не хочу": Gelmem!',
    examples: [
      {
        parts: [
          { text: 'Yarın gel', label: '', why: '' },
          { text: 'eceğim', label: 'решено (-ecek)', why: 'план, решение уже принято' },
        ],
        ru: 'Завтра приду (так решено).',
      },
      {
        parts: [
          { text: 'Tamam, gel', label: '', why: '' },
          { text: 'irim', label: 'обещаю (-ir)', why: 'ответ на просьбу - готовность, обещание' },
        ],
        ru: 'Хорошо, приду.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'ответ на просьбу',
        context: { tr: '- Yarın gelir misin? - Tamam, ___.', ru: '- Придёшь завтра? - Хорошо, приду.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'irim', options: ['irim', 'mem', 'dim'], label: 'обещаю (-ir)', why: 'tamam - согласие, ответ на просьбу - обещание: -ir; gelmem - отказ, geldim - прошедшее' },
        ],
        answer: 'gelirim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'taşın',
        baseRu: 'переезжать',
        task: 'план, решено · мы',
        context: { tr: 'Gelecek yıl İzmir\'e ___.', ru: 'В следующем году мы переезжаем в Измир (уже решили).' },
        slots: [
          { answer: 'taşın', options: [], label: '', why: '' },
          { answer: 'acağız', options: ['acağız', 'ırız', 'dık'], label: 'решено (-ecek)', why: 'план, решённый заранее - -ecek; taşınırız - "может, и переедем"' },
        ],
        answer: 'taşınacağız',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ara',
        baseRu: 'звонить',
        task: 'обещание',
        context: { tr: 'Söz veriyorum, yarın seni ___.', ru: 'Обещаю, завтра я тебе позвоню.' },
        slots: [
          { answer: 'ara', options: [], label: '', why: '' },
          { answer: 'rım', options: ['rım', 'dım', 'rsın'], label: 'обещаю (-ir)', why: 'обещание - -ir; после гласной просто -r; обещаю "я" - -rım' },
        ],
        answer: 'ararım',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'уверен (kesinlikle)',
        context: { tr: 'Kesinlikle ___.', ru: 'Обязательно приду.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'eceğim', options: ['eceğim', 'ecek', 'dim'], label: 'решено (-ecek)', why: 'с kesinlikle - -ecek, "я" - -eceğim; gelecek - "он придёт"' },
        ],
        answer: 'geleceğim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'et',
        baseRu: 'делать (etmek)',
        task: 'ответ на просьбу',
        context: { tr: '- Bana yardım eder misin? - Tabii, ___.', ru: '- Поможешь мне? - Конечно, помогу.' },
        slots: [
          { answer: 'ed', options: [], label: '', why: 't перед гласной становится d' },
          { answer: 'erim', options: ['erim', 'er', 'iyorum'], label: 'обещаю (-ir)', why: 'ответ на просьбу - -ir: ederim звучит тепло, "конечно, помогу"; eder - "он"; ediyorum - "помогаю сейчас"' },
        ],
        answer: 'ederim',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'yap',
        baseRu: 'делать',
        task: 'отказ',
        context: { tr: 'Bunu ___!', ru: 'Я этого делать не буду! (не хочу)' },
        slots: [
          { answer: 'yap', options: [], label: '', why: '' },
          { answer: 'mam', options: ['mam', 'amam', 'madım'], label: 'отказ (-mem)', why: 'отказ, "не хочу" - -mam; yapamam - "не могу", yapmadım - "не сделал"' },
        ],
        answer: 'yapmam',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'unut',
        baseRu: 'забывать',
        task: 'клятва',
        context: { tr: 'Seni asla ___.', ru: 'Я тебя никогда не забуду.' },
        slots: [
          { answer: 'unut', options: [], label: '', why: '' },
          { answer: 'mam', options: ['mam', 'madım', 'urum'], label: 'клятва (-mem)', why: 'клятва - это обещание, поэтому -mam; unutmadım - "не забыл", unuturum с asla не сочетается' },
        ],
        answer: 'unutmam',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Yarın geleceğim.',
        sourceRu: 'завтра приду (решено)',
        instruction: 'Ответьте на просьбу "Yarın gelir misin?" - пообещайте (-ir)',
        answer: 'Tamam, gelirim.',
        variants: ['Gelirim.', 'Tamam, yarın gelirim.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'irim', label: 'обещаю (-ir)', why: 'решение рождается сейчас, в ответ на просьбу' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Может быть, приду.',
        instruction: 'Скажите это по-турецки: не уверены - какое время?',
        answer: 'Belki gelirim.',
        variants: [],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'irim', label: 'может быть (-ir)', why: 'с belki естественно -ir' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'В следующем году я перееду в Измир (уже решила).',
        instruction: 'Скажите это по-турецки',
        answer: 'Gelecek yıl İzmir\'e taşınacağım.',
        variants: ['Gelecek yıl İzmir\'e taşınıyorum.'],
        breakdown: [
          { text: 'taşın', label: '', why: '' },
          { text: 'acağım', label: 'решено (-ecek)', why: 'план - -ecek; "taşınırım" прозвучит как "может, и перееду"' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l047 — kadar и gibi.
  {
    rule: 'comparison-scale-full',
    explain: 'kadar - "такой же... как", про степень: Ali benim kadar uzun. gibi - "как, подобно", про сходство: Senin gibi konuşuyorum. Местоимение перед ними - в родительном (benim, senin, onun; но onlar), а обычное слово - как есть: Ali kadar, annem gibi.',
    examples: [
      {
        parts: [
          { text: 'Ali ben', label: '', why: '' },
          { text: 'im', label: 'родительный', why: 'местоимение перед kadar - benim' },
          { text: ' kadar', label: 'такой же, как', why: 'степень: рост одинаковый' },
          { text: ' uzun', label: '', why: '' },
        ],
        ru: 'Али такого же роста, как я.',
      },
      {
        parts: [
          { text: 'Sen', label: '', why: '' },
          { text: 'in', label: 'родительный', why: 'местоимение перед gibi - senin' },
          { text: ' gibi', label: 'как, подобно', why: 'сходство: та же манера' },
          { text: ' konuşmak istiyorum', label: '', why: '' },
        ],
        ru: 'Я хочу говорить, как ты.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'ben',
        baseRu: 'я',
        task: 'родительный перед kadar',
        context: { tr: 'Ali ___ kadar uzun.', ru: 'Али такого же роста, как я.' },
        slots: [
          { answer: 'ben', options: [], label: '', why: '' },
          { answer: 'im', options: ['im', 'i', 'den'], label: 'родительный', why: 'местоимение перед kadar и gibi - в родительном: benim' },
        ],
        answer: 'benim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'sen',
        baseRu: 'ты',
        task: 'родительный перед gibi',
        context: { tr: '___ gibi konuşmak istiyorum.', ru: 'Я хочу говорить, как ты.' },
        slots: [
          { answer: 'sen', options: [], label: '', why: '' },
          { answer: 'in', options: ['in', 'i', 'den'], label: 'родительный', why: '"sen gibi" - ошибка: senin gibi' },
        ],
        answer: 'senin',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'o',
        baseRu: 'он, она',
        task: 'родительный перед kadar',
        context: { tr: 'Ben ___ kadar sabırlı değilim.', ru: 'Я не такая терпеливая, как она.' },
        slots: [
          { answer: 'o', options: [], label: '', why: '' },
          { answer: 'nun', options: ['nun', 'nu', 'ndan'], label: 'родительный', why: 'o - onun kadar; kadar + değil - "не такой... как"' },
        ],
        answer: 'onun',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'o',
        baseRu: 'то',
        task: 'падеж при farklı',
        context: { tr: 'Bu elbise ___ farklı.', ru: 'Это платье не такое, как то.' },
        slots: [
          { answer: 'o', options: [], label: '', why: '' },
          { answer: 'ndan', options: ['ndan', 'nun', 'na'], label: 'от чего? (-den)', why: 'farklı просит -den, как в сравнении -den daha' },
        ],
        answer: 'ondan',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'yıl',
        baseRu: 'год',
        task: 'падеж при kıyasla',
        context: { tr: 'Geçen ___ kıyasla daha mutluyum.', ru: 'По сравнению с прошлым годом я счастливее.' },
        slots: [
          { answer: 'yıl', options: [], label: '', why: '' },
          { answer: 'a', options: ['a', 'dan', 'ın'], label: 'к чему? (-e)', why: 'kıyasla просит дательный: -e kıyasla' },
        ],
        answer: 'yıla',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Onun gibi konuşuyorsun.',
        sourceRu: 'ты говоришь, как он',
        instruction: 'Замените "он" на имя Ali',
        answer: 'Ali gibi konuşuyorsun.',
        variants: [],
        breakdown: [
          { text: 'Ali', label: '', why: '' },
          { text: ' gibi', label: 'как, подобно', why: 'имя перед gibi - как есть, без родительного: не "Ali\'nin gibi"' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Ben senin kadar uzunum.',
        sourceRu: 'я такой же высокий, как ты',
        instruction: 'Скажите "я не такой высокий, как ты"',
        answer: 'Ben senin kadar uzun değilim.',
        variants: ['Senin kadar uzun değilim.'],
        breakdown: [
          { text: 'değil', label: '', why: '' },
          { text: 'im', label: 'я', why: 'kadar + değil - самый турецкий способ сказать "менее"' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Бегаю так же быстро, как он.',
        instruction: 'Скажите это по-турецки',
        answer: 'Onun kadar hızlı koşuyorum.',
        variants: ['Ben onun kadar hızlı koşuyorum.', 'Onun kadar hızlı koşarım.', 'Ben onun kadar hızlı koşarım.'],
        breakdown: [
          { text: 'o', label: '', why: '' },
          { text: 'nun', label: 'родительный', why: '' },
          { text: ' kadar', label: 'такой же, как', why: 'скорость одна - степень, поэтому kadar' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Неужели так дорого?',
        instruction: 'Скажите это по-турецки',
        answer: 'Bu kadar pahalı mı?',
        variants: ['O kadar pahalı mı?'],
        breakdown: [
          { text: 'Bu', label: '', why: '' },
          { text: ' kadar', label: 'настолько', why: 'bu kadar, o kadar - "настолько, так"' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l048 — предпочтение: -i -e tercih etmek, en iyi.
  {
    rule: 'comparison-preference',
    explain: 'Что чему предпочитаем: выбранное - в винительном (-ı), отвергнутое - в дательном (-e): Çayı kahveye tercih ederim. Не путайте с daha çok sevmek, где второй предмет с -den: Çayı kahveden daha çok severim. "Самый" - через en: en iyi, en kötü, en çok.',
    examples: [
      {
        parts: [
          { text: 'Çay', label: '', why: '' },
          { text: 'ı', label: 'что? (-ı)', why: 'выбранное - в винительном' },
          { text: ' kahve', label: '', why: '' },
          { text: 'ye', label: 'чему? (-e)', why: 'отвергнутое - в дательном' },
          { text: ' tercih ederim', label: '', why: '' },
        ],
        ru: 'Я предпочитаю чай кофе.',
      },
      {
        parts: [
          { text: 'O benim ', label: '', why: '' },
          { text: 'en', label: 'самый (en)', why: 'iyi - daha iyi - en iyi' },
          { text: ' iyi arkadaşım', label: '', why: '' },
        ],
        ru: 'Он мой лучший друг.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'çay',
        baseRu: 'чай',
        task: 'что выбираю (-ı)',
        context: { tr: '___ kahveye tercih ederim.', ru: 'Я предпочитаю чай кофе.' },
        slots: [
          { answer: 'çay', options: [], label: '', why: '' },
          { answer: 'ı', options: ['ı', 'a', 'dan'], label: 'что? (-ı)', why: 'выбранное - в винительном: çayı' },
        ],
        answer: 'çayı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kahve',
        baseRu: 'кофе',
        task: 'чему предпочитаю (-e)',
        context: { tr: 'Çayı ___ tercih ederim.', ru: 'Я предпочитаю чай кофе.' },
        slots: [
          { answer: 'kahve', options: [], label: '', why: '' },
          { answer: 'ye', options: ['ye', 'den', 'yi'], label: 'чему? (-e)', why: 'tercih etmek - отвергнутое в дательном; после гласной - y' },
        ],
        answer: 'kahveye',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'dağ',
        baseRu: 'гора',
        task: 'чему предпочитаю (-e)',
        context: { tr: 'Denizi ___ tercih ederim.', ru: 'Море я предпочитаю горам.' },
        slots: [
          { answer: 'dağ', options: [], label: '', why: '' },
          { answer: 'a', options: ['a', 'dan', 'ı'], label: 'чему? (-e)', why: 'tercih etmek - -e; последняя a, поэтому -a' },
        ],
        answer: 'dağa',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kahve',
        baseRu: 'кофе',
        task: 'падеж при daha çok sevmek',
        context: { tr: 'Çayı ___ daha çok severim.', ru: 'Чай я люблю больше, чем кофе.' },
        slots: [
          { answer: 'kahve', options: [], label: '', why: '' },
          { answer: 'den', options: ['den', 'ye', 'yi'], label: 'чем? (-den)', why: 'daha çok sevmek - -den; tercih etmek - -e. Смысл тот же, падеж другой' },
        ],
        answer: 'kahveden',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'koş',
        baseRu: 'бегать',
        task: 'чему предпочитаю (-meye)',
        context: { tr: 'Yürümeyi ___ tercih ederim.', ru: 'Ходить мне нравится больше, чем бегать.' },
        slots: [
          { answer: 'koş', options: [], label: '', why: '' },
          { answer: 'maya', options: ['maya', 'mayı', 'maktan'], label: 'чему? (-meye)', why: 'действие тоже можно предпочитать: -meyi ... -meye tercih etmek' },
        ],
        answer: 'koşmaya',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'hangi',
        baseRu: 'какой',
        task: 'какой из этих (-ı)',
        context: { tr: '___ tercih edersiniz?', ru: 'Какой (из этих) вы предпочитаете?' },
        slots: [
          { answer: 'hangi', options: [], label: '', why: '' },
          { answer: 'sini', options: ['sini', 'si', 'sine'], label: 'что? (-ı)', why: 'выбор из конкретных - винительный: hangisini' },
        ],
        answer: 'hangisini',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Denizi dağdan daha çok severim.',
        sourceRu: 'море я люблю больше, чем горы',
        instruction: 'Скажите то же через tercih etmek',
        answer: 'Denizi dağa tercih ederim.',
        variants: [],
        breakdown: [
          { text: 'dağ', label: '', why: '' },
          { text: 'a', label: 'чему? (-e)', why: 'daha çok sevmek - -den, tercih etmek - -e; "dağdan tercih ederim" - ошибка' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Он мой лучший друг.',
        instruction: 'Скажите это по-турецки',
        answer: 'O benim en iyi arkadaşım.',
        variants: ['O en iyi arkadaşım.'],
        breakdown: [
          { text: 'en', label: 'самый (en)', why: 'iyi - daha iyi - en iyi' },
          { text: ' iyi', label: '', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Больше всего я люблю рыбу.',
        instruction: 'Скажите это по-турецки',
        answer: 'En çok balık severim.',
        variants: ['En çok balığı severim.', 'En çok balık seviyorum.', 'En çok balığı seviyorum.'],
        breakdown: [
          { text: 'En', label: 'самый (en)', why: 'en çok - "больше всего"' },
          { text: ' çok', label: '', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l050 — глаголы на -la / -le.
  {
    rule: 'verbalizing-suffix-la',
    explain: 'Многие глаголы собраны из знакомого слова и -la / -le: temiz - temizlemek, plan - planlamak, kira - kiralamak. Гармония двойная: после a, ı, o, u - -la, после e, i, ö, ü - -le. Перед -yor a сужается в ı, e - в i: planlıyorum, temizliyorum.',
    examples: [
      {
        parts: [
          { text: 'temiz', label: '', why: '' },
          { text: 'le', label: 'глагол (-le)', why: 'последняя гласная i, поэтому -le' },
          { text: 'mek', label: '', why: '' },
        ],
        ru: 'чистить, убирать (temiz - чистый)',
      },
      {
        parts: [
          { text: 'Bütçemi plan', label: '', why: '' },
          { text: 'lı', label: 'глагол (-la)', why: 'a перед -yor сужается в ı: не "planlayor"' },
          { text: 'yorum', label: 'сейчас (-yor)', why: '' },
        ],
        ru: 'Я планирую свой бюджет.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'temiz',
        baseRu: 'чистый',
        task: 'глагол · приказ (ты)',
        context: { tr: 'Odayı ___!', ru: 'Убери комнату!' },
        slots: [
          { answer: 'temiz', options: [], label: '', why: '' },
          { answer: 'le', options: ['le', 'la', 'len'], label: 'глагол (-le)', why: 'последняя i, поэтому -le; повелительное - сама основа' },
        ],
        answer: 'temizle',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'hazır',
        baseRu: 'готовый',
        task: 'глагол · приказ (ты)',
        context: { tr: 'Kahvaltıyı ___!', ru: 'Приготовь завтрак!' },
        slots: [
          { answer: 'hazır', options: [], label: '', why: '' },
          { answer: 'la', options: ['la', 'le', 'lı'], label: 'глагол (-la)', why: 'последняя ı, поэтому -la' },
        ],
        answer: 'hazırla',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kira',
        baseRu: 'аренда',
        task: 'глагол · мы, прошедшее',
        context: { tr: 'Bir ev ___.', ru: 'Мы сняли дом.' },
        slots: [
          { answer: 'kira', options: [], label: '', why: '' },
          { answer: 'la', options: ['la', 'le'], label: 'глагол (-la)', why: 'последняя a, поэтому -la' },
          { answer: 'dık', options: ['dık', 'dik', 'tık'], label: 'мы, прошедшее', why: 'после гласной - d; последняя a, поэтому -dık' },
        ],
        answer: 'kiraladık',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ütü',
        baseRu: 'утюг',
        task: 'глагол · приказ (ты)',
        context: { tr: 'Gömleğini ___.', ru: 'Погладь рубашку.' },
        slots: [
          { answer: 'ütü', options: [], label: '', why: '' },
          { answer: 'le', options: ['le', 'la', 'yle'], label: 'глагол (-le)', why: 'последняя ü, поэтому -le' },
        ],
        answer: 'ütüle',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'plan',
        baseRu: 'план',
        task: 'глагол · сейчас (я)',
        context: { tr: 'Bu akşam bütçemi ___.', ru: 'Сегодня вечером я планирую бюджет.' },
        slots: [
          { answer: 'plan', options: [], label: '', why: '' },
          { answer: 'lıyorum', options: ['lıyorum', 'layorum', 'liyorum'], label: 'глагол + сейчас', why: 'a перед -yor сужается в ı: planlıyorum, не "planlayorum"' },
        ],
        answer: 'planlıyorum',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'temiz',
        baseRu: 'чистый',
        task: 'глагол · сейчас (я)',
        context: { tr: 'Şimdi mutfağı ___.', ru: 'Сейчас я убираю кухню.' },
        slots: [
          { answer: 'temiz', options: [], label: '', why: '' },
          { answer: 'liyorum', options: ['liyorum', 'leyorum', 'lıyorum'], label: 'глагол + сейчас', why: 'e перед -yor сужается в i: temizliyorum' },
        ],
        answer: 'temizliyorum',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'plan',
        baseRu: 'план',
        task: 'глагол · обычно (я)',
        context: { tr: 'Bütçemi her hafta ___.', ru: 'Я каждую неделю планирую бюджет.' },
        slots: [
          { answer: 'plan', options: [], label: '', why: '' },
          { answer: 'larım', options: ['larım', 'lerim', 'lırım'], label: 'глагол + обычно (-r)', why: 'глаголы на -la правильные: широкое - просто -r, planlarım' },
        ],
        answer: 'planlarım',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Oda temiz değil.',
        sourceRu: 'комната не чистая',
        instruction: 'Попросите убрать комнату: глагол из temiz',
        answer: 'Odayı temizle!',
        variants: ['Odayı temizler misin?', 'Odayı temizleyin!'],
        breakdown: [
          { text: 'temiz', label: '', why: '' },
          { text: 'le', label: 'глагол (-le)', why: 'temiz + -le = temizle-; повелительное - сама основа' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Я готовлю завтрак.',
        instruction: 'Скажите это по-турецки',
        answer: 'Kahvaltıyı hazırlıyorum.',
        variants: ['Kahvaltı hazırlıyorum.'],
        breakdown: [
          { text: 'hazır', label: '', why: '' },
          { text: 'lı', label: 'глагол (-la)', why: 'a перед -yor становится ı' },
          { text: 'yorum', label: 'сейчас (-yor)', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Этим летом мы снимаем дом.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bu yaz bir ev kiralıyoruz.',
        variants: ['Bu yaz ev kiralıyoruz.'],
        breakdown: [
          { text: 'kira', label: '', why: '' },
          { text: 'lı', label: 'глагол (-la)', why: 'a перед -yor становится ı: kiralıyoruz' },
          { text: 'yoruz', label: 'сейчас, мы (-yor)', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },
]
